import { CreateTicketResult } from '../types/ticket';
import { fcMovideskHttpClient } from './httpClient';

type CreateTicketParams = {
  name: string;
  phone: string;
  email: string;
  cpfCnpj: string;
  description: string;
  category: string;
  serviceFirstLevelId: number;
  storeTypeId: string;
  /** O BFF exige o campo mesmo quando não há filial a reportar (canal `loja_online`) — nesse caso vai vazio. */
  branchId: string;
  attachments: File[];
  /** Token do reCAPTCHA v3, de uso único; o BFF o valida antes de falar com o Movidesk. */
  captchaToken: string;
};

export async function createTicket(params: CreateTicketParams): Promise<CreateTicketResult> {
  const formData = new FormData();
  formData.append('name', params.name);
  formData.append('phone', params.phone);
  formData.append('email', params.email);
  formData.append('cpfCnpj', params.cpfCnpj);
  formData.append('description', params.description);
  formData.append('category', params.category);
  formData.append('serviceFirstLevelId', String(params.serviceFirstLevelId));
  formData.append('storeTypeId', params.storeTypeId);
  formData.append('branchId', params.branchId);
  formData.append('captchaToken', params.captchaToken);
  params.attachments.forEach((file) => formData.append('attachments', file));

  return fcMovideskHttpClient.post<CreateTicketResult>('/create-ticket', formData);
}
